import React from 'react';
import logoUrl from '~/assets/images/logo-moneyview.png';

const PoweredByMoneyViewLogo: React.FC = () => (
  <img
    src={logoUrl}
    className="w-[110px] h-[17px] md:w-[140px] md:h-[21px]"
    alt="MoneyView"
  />
);

export default PoweredByMoneyViewLogo;